import type { Resource } from '../../';
export const product_sizeChart_descriptionBottom: Resource = {"default":""};
